import Vue from 'vue'
import App from './wentilv.vue'
import router from './router'
import { store } from '../../store'
import '@vant/touch-emulator'
Vue.config.productionTip = false

// vant组件
import {
    List,
    Loading,
    Cell,
    CellGroup,
    Image,
    Lazyload,
    ImagePreview,
    Tab,
    Tabs,
    sticky,
    Toast,
    PullRefresh,
    Swipe,
    SwipeItem
} from "vant"
Vue.use(List)
    .use(Loading)
    .use(Cell)
    .use(CellGroup)
    .use(Image)
    .use(Lazyload)
    .use(ImagePreview)
    .use(Tab)
    .use(Tabs)
    .use(sticky)
    .use(Toast)
    .use(PullRefresh)
    .use(Swipe)
    .use(SwipeItem)

// 多页跳转
const pagesJump = (path) => {
    if (location.hostname === 'localhost') {
        window.location.href = path;
    } else {
        const http = window.location.protocol + '//' + location.hostname + ':' + location.port;
        window.location.href = http + '/h5' + path; //（服务器的路径）
    }
}
Vue.prototype.pagesJump = pagesJump;

/* 全局css */
import './css/main.css'
/* 网页title */
Vue.use(require('vue-wechat-title'))

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
